import { useNavigate } from "react-router-dom";
import "./RefundShared.css";

const Refund1 = () => {
    const navigate = useNavigate();

    const relatedArticles = [
        {
            title: "What payment methods do you accept?",
            description: "Learn about the different payment options available for our services.",
            link: "/what-payment-methods-do-you-accept?"
        },
        {
            title: "How long does it take to process a refund?",
            description: "Understand the timeline for refund processing and when to expect your money back.",
            link: "/how-long-does-it-take-to-process-a-refund?"
        }
    ];

    return (
        <div className="rf-container">
            <header className="rf-header">
                <div className="rf-container-1200">
                    {/* <div className="rf-header-content">
                        <button 
                            className="rf-back-btn"
                            onClick={() => navigate(-1)}
                        >
                            <FaArrowLeft /> Back
                        </button>
                        <div className="rf-logo">
                            <a href="/">BooksComply</a>
                        </div>
                        <div className="rf-top-bar">
                            <a href="/submitrequest" className="rf-submit-btn">
                                <FaQuestionCircle className="btn-icon" /> Submit a request
                            </a>
                        </div>
                    </div> */}
                </div>
            </header>
            
            <main className="rf-main-content">
                <div className="rf-container-1200">
                    <nav className="rf-breadcrumb">
                        <ol>
                            <li><a href="/help">Help Center</a></li>
                            <li><a href="/refund">Refund and Pricing</a></li>
                            <li>Refund Policy</li>
                        </ol>
                    </nav>

                    <article className="rf-article">
                        <header className="rf-article-header">
                            <h1 className="rf-article-title">What is your refund policy?</h1>
                            <div className="rf-article-meta">
                                <span>Posted by BooksComply Team</span>
                                <span>•</span>
                                <span>Last updated August 2025</span>
                            </div>
                        </header>
                        
                        <div className="rf-article-content">
                            <p>
                                We offer a refund if you contact us within 14 days of your purchase. Please note that applicable charges will be deducted before processing the refund.
                            </p>
                            
                            {/* <h3>Refund Eligibility</h3>
                            <ul>
                                <li>Request must be made within 14 days of purchase</li>
                                <li>Service must not have been utilized</li>
                                <li>Documentation may be required for verification</li>
                            </ul>
                            
                            <h3>Processing Time</h3>
                            <p>
                                Once approved, refunds are typically processed within 5-7 business days. The time it takes for the refund to reflect in your account may vary depending on your payment method.
                            </p> */}
                        </div>
                    </article>
                    
                    {/* <div className="rf-helpful-section">
                        <h3 className="rf-helpful-title">Was this article helpful?</h3>
                        <div className="rf-helpful-buttons">
                            <button className="rf-helpful-btn positive">
                                <FaCheckCircle /> Yes, it was helpful
                            </button>
                            <button className="rf-helpful-btn negative">
                                <FaTimesCircle /> No, I need more help
                            </button>
                        </div>
                    </div> */}
                    
                    <div className="rf-related-articles">
                        <h2 className="rf-related-title">Related Articles</h2>
                        <div className="rf-related-grid">
                            {relatedArticles.map((article, index) => (
                                <a 
                                    key={index} 
                                    href={article.link} 
                                    className="rf-related-card"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(article.link);
                                    }}
                                >
                                    <h3>{article.title}</h3>
                                    <p>{article.description}</p>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Refund1;